// Helper functions for nav-drawer - v2 third level menus
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const navTrapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  navTrapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', navTrapFocusHandlers.keydown);
  };

  navTrapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', navTrapFocusHandlers.keydown);
  };

  navTrapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', navTrapFocusHandlers.focusout);
  document.addEventListener('focusin', navTrapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', navTrapFocusHandlers.focusin);
  document.removeEventListener('focusout', navTrapFocusHandlers.focusout);
  document.removeEventListener('keydown', navTrapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', function() {
  
  // Nav Drawer Component
  if (!customElements.get('nav-drawer')) {
    customElements.define('nav-drawer', 
      class NavDrawer extends HTMLElement {
      constructor() {
        super();
    
        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
          this.querySelector('#NavDrawer-Overlay').addEventListener('click', this.close.bind(this));
          this.setHeaderNavIconAccessibility();
        }
      
        setHeaderNavIconAccessibility() {
          const navLinks = document.querySelectorAll('.nav-icon-bubble');
          if (!navLinks) return;

          navLinks.forEach(navLink => {
            navLink.setAttribute('role', 'button');
            navLink.setAttribute('aria-haspopup', 'dialog');
            navLink.addEventListener('click', (event) => {
              event.preventDefault();
              
              // Get the nav-drawer component
              const navDrawer = document.querySelector('nav-drawer');
              
              // Check if drawer is currently open
              if (navDrawer.classList.contains('active')) {
                navDrawer.close();
              } else {
                navDrawer.open(navLink);
              }
            });
            navLink.addEventListener('keydown', (event) => {
              if (event.code.toUpperCase() === 'SPACE') {
            event.preventDefault();
                const navDrawer = document.querySelector('nav-drawer');
                if (navDrawer.classList.contains('active')) {
                  navDrawer.close();
                } else {
                  navDrawer.open(navLink);
                }
              }
            });
          });

          // Initialize submenu functionality
          this.initializeSubmenus();
        }
      
        initializeSubmenus() {
          // Handle submenu triggers
          document.addEventListener('click', (event) => {
            if (event.target.classList.contains('mobile-submenu-trigger')) {
              event.preventDefault();
              const submenuHandle = event.target.dataset.submenu;
              this.openSubmenu(submenuHandle);
            }

            if (event.target.classList.contains('mobile-submenu-drawer__back')) {
              event.preventDefault();
              const submenuHandle = event.target.dataset.submenu;
              this.closeSubmenu(submenuHandle);
            }

            if (event.target.classList.contains('mobile-submenu-drawer__overlay')) {
              event.preventDefault();
              const submenuDrawer = event.target.closest('.mobile-submenu-drawer');
              if (submenuDrawer) {
                const submenuHandle = submenuDrawer.dataset.submenu;
                this.closeSubmenu(submenuHandle);
              }
            }
          });

          // Handle escape key for submenus
          document.addEventListener('keydown', (event) => {
            if (event.code === 'Escape') {
              const activeSubmenu = document.querySelector('.mobile-submenu-drawer.active');
              if (activeSubmenu) {
                const submenuHandle = activeSubmenu.dataset.submenu;
                this.closeSubmenu(submenuHandle);
                event.preventDefault();
              }
            }
          });
        }
      
        openSubmenu(submenuHandle) {
          const submenuDrawer = document.getElementById(`submenu-${submenuHandle}`);
          if (submenuDrawer) {
            submenuDrawer.classList.add('active');
            // Add Tailwind classes for active state
            submenuDrawer.classList.remove('invisible', 'opacity-0');
            submenuDrawer.classList.add('visible', 'opacity-100');
            
            const inner = submenuDrawer.querySelector('.mobile-submenu-drawer__inner');
            if (inner) {
              inner.classList.remove('translate-x-full');
              inner.classList.add('translate-x-0');
            }
            
            document.body.classList.add('overflow-hidden');
            
            // Focus the back button for accessibility
            const backButton = submenuDrawer.querySelector('.mobile-submenu-drawer__back');
            if (backButton) {
              setTimeout(() => backButton.focus(), 300);
            }
          }
        }
      
        closeSubmenu(submenuHandle) {
          const submenuDrawer = document.getElementById(`submenu-${submenuHandle}`);
          if (submenuDrawer) {
            submenuDrawer.classList.remove('active');
            // Remove Tailwind classes for active state
            submenuDrawer.classList.remove('visible', 'opacity-100');
            submenuDrawer.classList.add('invisible', 'opacity-0');
            
            const inner = submenuDrawer.querySelector('.mobile-submenu-drawer__inner');
            if (inner) {
              inner.classList.remove('translate-x-0');
              inner.classList.add('translate-x-full');
            }
            
            // Check if any submenus are still open
            const activeSubmenus = document.querySelectorAll('.mobile-submenu-drawer.active');
            if (activeSubmenus.length === 0) {
              document.body.classList.remove('overflow-hidden');
            }
          }
      }
    
      open(triggeredBy) {
          // Close any open cart drawers first
          const openCartDrawers = document.querySelectorAll('cart-drawer.active');
          openCartDrawers.forEach(cartDrawer => {
            cartDrawer.close();
          });

        if (triggeredBy) this.setActiveElement(triggeredBy);
        // here the animation doesn't seem to always get triggered. A timeout seem to help
        setTimeout(() => {
          this.classList.add('animate', 'active');
        });
    
        this.addEventListener(
          'transitionend',
          () => {
              const containerToTrapFocusOn = this.querySelector('.drawer__inner');
            const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
            trapFocus(containerToTrapFocusOn, focusElement);
          },
          { once: true }
        );

          // Add 'open' class from nav-icon-bubble--mobile
          const navIcon = document.querySelector('#nav-icon-bubble--mobile div');
          if (navIcon) {
            navIcon.classList.add('open');
          }
    
        document.body.classList.add('overflow-hidden');
      }
    
      close() {
        this.classList.remove('active');
        removeTrapFocus(this.activeElement);
        document.body.classList.remove('overflow-hidden');
          // Remove 'open' class from nav-icon-bubble--mobile
          const navIcon = document.querySelector('#nav-icon-bubble--mobile div');
          if (navIcon) {
            navIcon.classList.remove('open');
          }
      }
    
      setActiveElement(element) {
        this.activeElement = element;
      }
    }
  );
}
});